import { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Sendrequest, onMessageListener } from '../config/firebase';
//import OneSignal from 'react-onesignal';

const Notificaciones = () => {
    const [notification, setNotification] = useState({ title: '', body: '' });
    const [acepto, setAcepto] = useState(false);
    const [initialized, setInitialized] = useState(false);

    //Sendrequest();

    useEffect(() => {
        console.log("MONTA NOTIFICACIONES")
        if(!initialized){
            /*
            OneSignal.init({ appId: 'd78f1f8a-e631-49d7-ba8b-b60acd4cf2b0' }).then((data) => {       
                OneSignal.log.setLevel('trace');
                OneSignal.showSlidedownPrompt();
                OneSignal.isPushNotificationsEnabled().then((data) => {
                    console.log(data)
                    console.log("ENABLED")
                })
                OneSignal.getUserId().then((data) => {
                    console.log(data)
                })
                console.log(data);
                setInitialized(true);
                OneSignal.registerForPushNotifications({
                    slidedown: true,
                    autoAccept:false
                    //modalPrompt: true
                }).then((data) => {
                    console.log(data)
                    console.log("METIO PERMISOS")
                });
                const permissions = OneSignal.notificationPermission;
                console.log(permissions);
                OneSignal.getNotificationPermission().then((data) => {
                    console.log(data)
                });
                
                OneSignal.showSlidedownPrompt().then((data) => {
                    console.log(data)
                    console.log("do other stuff")
                });
            })
            */
        }
    }, []);

    /*
    onMessageListener()
        .then((payload) => {
            console.log(payload);
            setNotification({ title: payload?.notification?.title, body: payload?.notification?.body });
        })
        .catch((err) => console.log('failed: ', err));

    useEffect(() => {
        if (notification?.title) {
            toast.success(notification?.title, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
        }
    }, [notification]);
*/
    const aceptaPermiso = () => {
        /*OneSignal.showSlidedownPrompt().then((data) => {
            console.log(data)
        });*/
        //Sendrequest()
        //setAcepto(true)
    }

       /* 
           {!acepto &&
            <button onClick={aceptaPermiso} className='btn btn-primary btn-sm'>Accept Push Message</button>
        }
       */
    return <>

        <ToastContainer />
    </>
}

export default Notificaciones